(() => {
  if (customElements.get('product-detail-tabs')) return;
  customElements.define('product-detail-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        });
      });
      this.select(0);
      this.editorSelect = event => {
        const panel = event.target.closest('[role="tabpanel"]');
        const index = this.panels.indexOf(panel);
        if (index !== -1) this.select(index);
      };
      this.addEventListener('shopify:block:select', this.editorSelect);
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
  });
})();
